import { AverageCaption, Caption, CaptionSmall, Line } from './styled.css';
import textData from '../../../../../../data/data.json';
import { selectedLanguageAtom } from '../../../../../../recoil/atoms/languageAtom';
import { useRecoilValue } from 'recoil';

export const AverageValue = ({ avgValue, maxQuestionValue }) => {
    const selectedLanguage = useRecoilValue(selectedLanguageAtom);
    const { averageValue } = textData[selectedLanguage];
    const lineHeight = (avgValue / maxQuestionValue) * 65 + 15 + '%';

    return (
        <>
            <Line lineHeight={lineHeight} />
            <AverageCaption lineHeight={lineHeight}>
                <CaptionSmall>{averageValue.text}</CaptionSmall>
                <Caption>{avgValue}</Caption>
            </AverageCaption>
        </>
    );
};
